// --- Style Definitions ---
// We define all styles as JavaScript objects to be used inline.
// This keeps styling consistent and scoped to components.

const styles = {
    // Global App Styles
    appContainer: {
        minHeight: '100vh',
        backgroundColor: '#FFFFFF', // White background
        color: '#333333', // Dark grey text for readability
        fontFamily: "'Open Sans', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        overflowX: 'hidden',
    },
    // Common Section Styling
    section: {
        width: '100%',
        padding: '4rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    // Typography
    h1: {
        fontSize: '3rem',
        fontWeight: 'bold',
        color: '#1A202C', // A darker, more professional shade
        marginBottom: '1rem',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    h2: {
        fontSize: '2.25rem',
        fontWeight: 'bold',
        color: '#2D3748', // Slightly lighter than h1
        marginBottom: '1rem',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    subheading: {
        fontSize: '1.25rem',
        color: '#4A5568', // A softer grey for subheadings
        maxWidth: '600px',
        lineHeight: '1.6',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    bodyText: {
        fontSize: '1rem',
        color: '#4A5568',
        lineHeight: '1.8',
        maxWidth: '700px',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    // Brand Colors
    brandColor: '#D50000', // The vibrant red from the logo

    // Responsive Design Placeholders (will be used in media queries)
    isMobile: '@media (max-width: 768px)',
};

export default styles;